import Radium from 'radium';

import { appConfig } from 'config/customization';
import { iconTitle } from 'constants/fonts';

const avatarBorderRadius = appConfig.authAvatarSquared ? 10 : 40;
const avatarWithShadow = appConfig.authAvatarWithShadow && '0px 2px 4px 0px rgba(0, 0, 0, 0.5)';
const avatarWithBackground = appConfig.authAvatarWithBackground && appConfig.colors.authAvatarBackground;

const scaleAndFadeAnimation = Radium.keyframes(
  {
    from: { transform: 'scale3d(0.75, 0.75, 1)', opacity: 0 },
    to: { transform: 'scale3d(1, 1, 1)', opacity: 0.94 }
  },
  'scaleAndfade'
);

export default {
  container: {
    backgroundColor: appConfig.colors.primaryButton,
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    zIndex: 9999,
    transformOrigin: 'center bottom',
    animationFillMode: 'forwards',
    animationName: scaleAndFadeAnimation,
    animationTimingFunction: 'ease',
    animationDuration: '0.5s'
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  logo: {
    margin: '0px 22px 12px'
  },
  imageLogo: {
    height: 65,
    width: 'auto',
    borderRadius: avatarBorderRadius,
    backgroundColor: avatarWithBackground,
    boxShadow: avatarWithShadow,
    position: 'relative',
    flexShrink: 0
  },
  closeButton: {
    color: appConfig.colors.white
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    minHeight: 225
  },
  logoAndText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  firstLine: {
    display: 'flex',
    marginBottom: 5
  },
  textWithBackground: {
    color: appConfig.colors.primaryButton,
    fontSize: iconTitle
  },
  textBackgroundContainer: {
    backgroundColor: 'white',
    marginLeft: 8,
    padding: '0px 2px'
  },
  secondLine: {
    display: 'flex',
    margin: '0px 30px',
    flexWrap: 'no-wrap'
  },
  textSpace: {
    padding: '0px 5px',
    fontSize: iconTitle
  },
  storesAndMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 10,
    flex: 1.5,
    flexShrink: 0
  },
  buttonsContainer: {
    display: 'flex',
    width: '80%',
    minHeight: 70
  },
  buttonImage: {
    width: '100%',
    height: 'auto'
  },
  mobileImage: {
    height: '75%',
    width: 'auto',
    maxHeight: 425
  },
  iconTitleSize: {
    fontSize: iconTitle
  }
};
